'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UILayer = require('../layer/UILayer');

var _UILayer2 = _interopRequireDefault(_UILayer);

var _focusStylesListener = require('../listeners/focusStylesListener');

var _component = require('../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Based on https://github.com/twbs/bootstrap/blob/v3.3.6/dist/js/bootstrap.js
function measureScrollbar() {
  var scrollDiv = document.createElement('div');
  scrollDiv.className = 'uiFullScreen-scrollbar-measure';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

exports.default = _react2.default.createClass({
  displayName: 'UIFullScreen',

  propTypes: {
    children: _react.PropTypes.element.isRequired,
    rootNode: _react.PropTypes.object,
    Transition: _component2.default
  },

  statics: {
    layerCount: 0,
    NO_SCROLL_CLASS: 'uiFullScreenBackground',
    originalBodyPaddingRight: ''
  },

  getInitialState: function getInitialState() {
    return {
      clonedChild: null
    };
  },
  componentWillMount: function componentWillMount() {
    this._lastFocus = document.activeElement;
    var child = _react2.default.Children.only(this.props.children);
    this.setState({
      clonedChild: _react2.default.cloneElement(child, {
        open: true
      })
    });
  },
  componentDidMount: function componentDidMount() {
    this.constructor.layerCount += 1;
    if (this.constructor.layerCount === 1) {
      this.disableBackgroundScrolling();
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.children !== nextProps.children) {
      this.setState({
        clonedChild: _react2.default.cloneElement(_react2.default.Children.only(nextProps.children), {
          open: true
        })
      });
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.constructor.layerCount -= 1;
  },
  handleCloseComplete: function handleCloseComplete() {
    if (this._lastFocus) {
      if ((0, _focusStylesListener.isPageInKeyboardMode)()) {
        this._lastFocus.focus();
      }
      this._lastFocus = null;
    }
    if (this.constructor.layerCount === 0) {
      this.restoreBackgroundScrolling();
    }
  },
  disableBackgroundScrolling: function disableBackgroundScrolling() {
    var _this = this;

    this.addFauxScrollbar();
    [document.documentElement, document.body].forEach(function (el) {
      return el.classList && el.classList.add(_this.constructor.NO_SCROLL_CLASS);
    });
  },
  restoreBackgroundScrolling: function restoreBackgroundScrolling() {
    var _this2 = this;

    this.removeFauxScrollbar();
    [document.documentElement, document.body].forEach(function (el) {
      return el.classList && el.classList.remove(_this2.constructor.NO_SCROLL_CLASS);
    });
  },
  addFauxScrollbar: function addFauxScrollbar() {
    var bodyHasScrollbar = document.body.clientWidth < window.innerWidth;
    if (bodyHasScrollbar) {
      var scrollbarWidth = measureScrollbar() + 'px';

      // To avoid changing the body width when we disable scrollbar, we replace
      // the scrollbar with padding of equal width.
      this.constructor.originalBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollbarWidth;
    }
  },
  removeFauxScrollbar: function removeFauxScrollbar() {
    document.body.style.paddingRight = this.constructor.originalBodyPaddingRight;
  },
  render: function render() {
    return _react2.default.createElement(
      _UILayer2.default,
      _extends({}, this.props, { onCloseComplete: this.handleCloseComplete }),
      this.state.clonedChild
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/dialog/UIFullScreen.js
// module id = 272
// module chunks = 3 4 5